export function getPublicConfigValue(key, fallback = '') {
    if (typeof window === 'undefined') {
        return fallback;
    }

    const value = window.__avariConfig?.[key];

    return typeof value === 'string' ? value : fallback;
}
